import React, {Component} from 'react';
import {Row, Col, Progress, Card, ButtonToolbar, Alert, CardHeader, CardTitle, FormGroup, Label, Form, Input, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, Button, ButtonDropdown, Table, Badge,  Pagination, PaginationItem, PaginationLink, DropdownMenu,DropdownToggle, ButtonGroup,Dropdown,DropdownItem, FormText, InputGroup,  Nav, NavItem, NavLink, TabContent, TabPane} from 'reactstrap';
import { ajaxWrapperPost, ajaxWrapperGet, ajaxWrapperDelete } from '../../../../utils/deviceAPI';
import classnames from 'classnames';
import LoadingIndicator from '../../../../utils/LoadingIndicator';
import UsersNotificationSystem from '../../../Admin/Users/UsersNotificationSystem';
import Select from 'react-select';
import 'react-select/dist/react-select.min.css';
import { DragSource, DragDropContext } from 'react-dnd';
import ComponentGenerator from './Components/ComponentGenerator';
import ComponentAts from './Components/ComponentAts';
import ComponentList from './Components/ComponentList';
import ComponentControlToggle from './Components/Control/ComponentToggle';

const myComponents = {
    'generator': ComponentGenerator,
    'ats': ComponentAts,
    'list': ComponentList,
    'controlToggle': ComponentControlToggle
};

class DeveloperOverviewRender extends Component {

    constructor(props) {
        super(props);
    }
    componentDidMount() {
    }
    componentWillUnmount(){
    }
    onDragStart = (e, rowNumber, rowDataItem) => {
        //console.log('rowDataItem: ', rowDataItem);
        e.target.classList.remove("draggable");
        e.target.classList.add("dragging");
        e.dataTransfer.setData("fromrownumber" , rowNumber);
        e.dataTransfer.setData("rowitem" , rowDataItem)
    };

    onDragEnd = (e) => {
        e.target.classList.add("draggable");
        e.target.classList.remove("dragging");
    };

    onDragOver = (e) => {
        e.preventDefault();
    };

    onDrop = (ev, toRowNumber) => {
        let rowDataItem = ev.dataTransfer.getData("rowitem");
        let fromRowNumber = ev.dataTransfer.getData("fromrownumber");
        this.props.dragtransfer(rowDataItem,toRowNumber,fromRowNumber)
    };

    selectRow = (e, rowId) => {
        e.preventDefault();
        if (this.props.row === rowId) {
            this.props.selectedrow(-1);
        }
        else {
            this.props.selectedrow(rowId);
        }
    };

    render() {
        return (
            <div>

                {this.props.overviewdata.map((row) => {
                    return (
                        <Row key={row.id}
                             className={this.props.developer ? "developer-row droppable" : ""}
                             onDragOver={this.props.developer ? (e) => this.onDragOver(e) : undefined }
                             onDrop={this.props.developer  ? (e) => this.onDrop(e, row.id) : undefined }
                        >
                            <Col sm="12">
                                {this.props.developer ?
                                <Row className="bg-secondary pt-2 pb-2">
                                    <Col sm="2">
                                        <Button block color="ghost-white" onClick={(e) => this.selectRow(e, row.id)}>{this.props.row === row.id ? "Deselect Row" : "Select Row"}</Button>
                                    </Col>
                                    <Col sm="10" className="text-right">
                                        <Button color="danger" onClick={() => this.props.deleterow(row.id)}><i className="fa fa-trash-o" aria-hidden="true"> </i></Button>
                                    </Col>
                                </Row> : "" }
                                <Row className={`${this.props.developer ? 'pt-3 pb-3' :''} ${this.props.row === row.id ? "selectedRow" : ""}`}>
                                    {row.rowData.map((rowData,index) => {
                                        const Component = myComponents[rowData.item];
                                        return (

                                            <Col sm={rowData.size.sm}
                                                 md={rowData.size.md}
                                                 lg={rowData.size.lg}
                                                 xl={rowData.size.xl}
                                                 key={rowData.order}
                                                 draggable={this.props.developer}
                                                 className="draggable developmentColumn"
                                                 onDragStart={this.props.developer ? (e)=>this.onDragStart(e, row.id, rowData.order) : undefined }
                                                 onDragEnd={this.props.developer ? (e)=>this.onDragEnd(e) : undefined }
                                            >
                                                {this.props.developer ?
                                                <Row>
                                                    <Col sm="12">
                                                        <Card className="developerItemToolbar">
                                                            <CardHeader>
                                                                <ButtonToolbar>
                                                                    <ButtonGroup className="mr-2">
                                                                        <Button color="light" onClick={() => this.props.expandchildsize(row.id, rowData.order)}><i className="fa fa-expand"> </i></Button>
                                                                        <Button color="light" onClick={() => this.props.deletecomponent(row.id, rowData.order)}><i className="fa fa-trash"> </i></Button>
                                                                    </ButtonGroup>
                                                                </ButtonToolbar>
                                                            </CardHeader>
                                                        </Card>
                                                    </Col>
                                                </Row> : "" }
                                                <Row>
                                                    <Col sm="12">
                                                        <Component developer={this.props.developer}
                                                                   componentdata={rowData.data}
                                                                   valuechangeinput={(textFieldName,textFieldValue) => this.props.savetextvaluechanges(row.id,rowData.order,textFieldName,textFieldValue)}
                                                                   iodb={this.props.iodb}
                                                                   tagBits={this.props.tagBits}
                                                                   iotData={this.props.iotData}
                                                                   desiredIotData={this.props.desiredIotData}
                                                                   addNewDataToChild={(schema, dataType) => this.props.addNewDataToChild(schema,row.id, rowData.order, dataType)}
                                                                   componentIsBeingEdited={(status) => this.props.componentIsBeingEdited(status)}
                                                                   writeControl={(tag,bit,state) => this.props.writeControl(tag,bit,state)}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                        )
                                    })}
                                </Row>
                            </Col>

                        </Row>
                    )
                })}
            </div>
        )
    }
}
DeveloperOverviewRender.defaultProps = {
    row : -1
};

export default DeveloperOverviewRender;



// WEBPACK FOOTER //
// ./src/views/site/Developer/DeveloperOverviewRender/DeveloperOverviewRender.js